var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2825 2.16666C14.7575 2.16666 18.3975 5.80666 18.3975 10.2817C18.3975 12.3929 17.5873 14.3186 16.2614 15.7637L18.8703 18.3672C19.1145 18.6114 19.1153 19.0064 18.8712 19.2506C18.7495 19.3739 18.5887 19.4347 18.4287 19.4347C18.2695 19.4347 18.1095 19.3739 17.987 19.2522L15.3465 16.6192C13.9576 17.7315 12.1964 18.3975 10.2825 18.3975C5.80749 18.3975 2.16666 14.7567 2.16666 10.2817C2.16666 5.80666 5.80749 2.16666 10.2825 2.16666ZM10.2825 3.41666C6.49666 3.41666 3.41666 6.49582 3.41666 10.2817C3.41666 14.0675 6.49666 17.1475 10.2825 17.1475C14.0675 17.1475 17.1475 14.0675 17.1475 10.2817C17.1475 6.49582 14.0675 3.41666 10.2825 3.41666Z",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch2);
export default __webpack_public_path__ + "static/media/Search2.f75571ee25f86120f020b19106415e2e.svg";
export { ForwardRef as ReactComponent };